import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {ButtonGroup, Button, Icon} from 'kpc';

var _$tmp0 = {
    'className': 'k-icon-notification-fill'
};
var _$tmp1 = {
    'className': 'k-icon-time'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(ButtonGroup, {
        'children': [
            _$cc(Button, {
                'ev-click': this.showNotificationIcon,
                'children': (
                    _$cc(Icon, _$tmp0)
                )
            }),
            _$cc(Button, {
                'ev-click': this.showTimeIcon,
                'children': (
                    _$cc(Icon, _$tmp1)
                )
            })
        ]
    });
};